import React, { Component } from 'react';
import { Tab, Row, Col, Nav, NavItem } from 'react-bootstrap';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import MaintenanceServices from './services';
import ConfirmRemoveModal from './confirmation-remove-modal';
import * as MaintenanceEnums from './maintenance-enums';

import home_icon from 'assets/img/home.svg';
import cube_icon from 'assets/img/cube.svg';
import time_icon from 'assets/img/time.svg';
import trash_icon from 'assets/img/trash.svg';
import refresh_icon from 'assets/img/refresh.svg';
import flag_black_icon from 'assets/img/flag-black.svg';

import './maintenance.scss';

export class MaintenanceTaskList extends Component {
    static propTypes = {
      history: PropTypes.object,
      dispatch: PropTypes.func,
      projectId: PropTypes.string,
      taskList: PropTypes.array,
      activeTabKey: PropTypes.number,
      goToEditScreen: PropTypes.func,
      goToAddScreen: PropTypes.func,
      onSelectTab: PropTypes.func
    }

    constructor(props) {
      super(props);
      this.maintenanceService = new MaintenanceServices(this.props.dispatch);

      this.state = {
        taskList: []
      };

      this.activeTabKey = this.props.activeTabKey;
    }

    componentDidMount() {
      this.maintenanceService.getTaskList(this.props.projectId, this.activeTabKey);
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.taskList) {
        this.setState({taskList: nextProps.taskList});
      }
    }

    // manual events
    onClickRemoveIcon = (e) => {
      this.setState({
        confirmRemoveModal: true,
        confirmedItem: e
      });
    }

    onClickCancelButton = () => {
      this.setState({
        confirmedItem: null,
        confirmRemoveModal: false
      });
    }

    onClickDeleteButton = () => {
      this.maintenanceService.removeTaskById(
        this.state.confirmedItem.id,
        !this.state.confirmedItem.inventoryItem,
        () => {
          this.maintenanceService.getTaskList(this.props.projectId, this.activeTabKey);
          this.setState({
            confirmedItem: null,
            confirmRemoveModal: false
          });
        });
    }

    onSelectTab = (tabKey) => {
      this.activeTabKey = (tabKey === 'general-maintenance-task' ? 0 : 1);
      this.props.onSelectTab(this.activeTabKey);
      this.maintenanceService.getTaskList(
        this.props.projectId,
        this.activeTabKey
      );
    }

    // manual events
    renderGeneralItemRow = (e) => {
      return (
        <div key={e.id} className='row'>
          <div className='col-md-8'>
            <img className='icon-first-col' src={e.recurringType ? time_icon : refresh_icon} />
            <div className='block-with-text' onClick={() => this.props.goToEditScreen(e)}>
              <b>{e.name}</b><br/>
              {e.description}
            </div>
          </div>

          <div className='col-md-2' style={{paddingTop: '24px'}}>
            <img className='icon' src={home_icon} />
            <div className='sub-block-text'>
              {e.applyToAllLots ? 'All lots' : `${e.totalLots} lots`}
            </div>
          </div>

          <div className='col-md-2' style={{position: 'relative', paddingTop: '24px'}}>
            <img className='icon' src={flag_black_icon} />
            <div className='sub-block-text'>
              {MaintenanceEnums.REPEAT_PERIODS_LIST[e.repeatType]}
            </div>
            <img
              className='icon icon-last'
              src={trash_icon} onClick={() => this.onClickRemoveIcon(e)}
            />
          </div>
        </div>
      );
    }

    renderSpecificItemRow = (e) => {
      return (
        <div key={e.id} className='row'>
          <div className='col-md-6'>
            <img className='icon-first-col' src={e.recurringType ? time_icon : refresh_icon} />
            <div className='block-with-text' onClick={() => this.props.goToEditScreen(e)}>
              <b>{e.name}</b><br/>
              {e.description}
            </div>
          </div>

          <div className='col-md-2' style={{paddingTop: '24px'}}>
            <img className='icon' src={cube_icon} />
            <div className='sub-block-text'>
              {
                e.inventoryItem &&
                <Link target='_blank' to={this.maintenanceService.buildUrlToInventoryItem(this.props.projectId, e.inventoryItem.id)}>
                  {e.inventoryItem.name}
                </Link>
              }
              {!e.inventoryItem && '--'}
            </div>
          </div>

          <div className='col-md-2' style={{paddingTop: '24px'}}>
            <img className='icon' src={home_icon} />
            <div className='sub-block-text'>
              {e.applyToAllLots ? 'All lots' : `${e.totalLots} lots`}
            </div>
          </div>

          <div className='col-md-2' style={{position: 'relative', paddingTop: '24px'}}>
            <img className='icon' src={flag_black_icon} />
            <div className='sub-block-text'>
              {MaintenanceEnums.REPEAT_PERIODS_LIST[e.repeatType]}
            </div>
            <img
              className='icon icon-last'
              src={trash_icon} onClick={() => this.onClickRemoveIcon(e)}
            />
          </div>
        </div>
      );
    }

    renderGeneralTaskList() {
      return (
        <React.Fragment>
          <button className='btn btn-primary btn-siteone'onClick={() => this.props.goToAddScreen()}>
            <span className='fa fa-plus icon' /> NEW
          </button>
          <div className='container-fluid maintenance-task-list' >
            {
              Array.isArray(this.state.taskList) &&
              this.state.taskList
                .sort((prev,next) => prev.name && next.name && prev.name.localeCompare(next.name))
                .map(this.renderGeneralItemRow)
            }
          </div>
          {
            this.state.confirmRemoveModal &&
            <ConfirmRemoveModal
              onClose={this.onClickCancelButton}
              onRemove={this.onClickDeleteButton}
              item={this.state.confirmedItem}
            />
          }
        </React.Fragment>
      );
    }

    renderSpecificTaskList() {
      return (
        <React.Fragment>
          <div className='container-fluid maintenance-task-list' style={{marginTop: 0}} >
            {
              Array.isArray(this.state.taskList) &&
              this.state.taskList
                .sort((prev,next) => prev.name && next.name && prev.name.localeCompare(next.name))
                .map(this.renderSpecificItemRow)
            }
          </div>
          {
            this.state.confirmRemoveModal &&
            <ConfirmRemoveModal
              onClose={this.onClickCancelButton}
              onRemove={this.onClickDeleteButton}
              item={this.state.confirmedItem}
            />
          }
        </React.Fragment>
      );
    }
    render() {
      return (
        <Tab.Container
          className='s1-stack-tab'
          id='maintenance-schedule-task-list'
          defaultActiveKey={this.activeTabKey ? 'specific-maintenance-task' : 'general-maintenance-task'}
          onSelect={this.onSelectTab}
        >
          <Row className='clearfix'>
            <Col sm={12}>
              <Nav bsStyle='tabs'>
                <NavItem eventKey='general-maintenance-task'>General Maintenance Tasks</NavItem>
                <NavItem eventKey='specific-maintenance-task'>Inventory-specific Maintenance Tasks</NavItem>
              </Nav>
            </Col>
            <Col sm={12}>
              <Tab.Content animation>
                <Tab.Pane eventKey='general-maintenance-task'>
                  {this.renderGeneralTaskList()}
                </Tab.Pane>
                <Tab.Pane eventKey='specific-maintenance-task'>
                  {this.renderSpecificTaskList()}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      );
    }
}

const mapStateToProps = (state) => {
  return {
    taskList: state.ProjectStore.MaintenanceTaskList
  };
};

export default connect(mapStateToProps)(MaintenanceTaskList);



// WEBPACK FOOTER //
// ./src/Projects/Components/Maintenance/task-list.js